<template>
  <div>
    <div v-for="(dialog, index) in popups" :key="index">
      <v-dialog v-model="dialog.isVisible" :width="dialog.width" persistent :set="(isFormValid = false)">
        <v-card flat>
          <v-card-title class="primary--text text-center">
            <img :src="$logos.dialog" alt="XTUR Sp. z o.o." />
            <v-spacer />
            {{ dialog.title }}
            <v-spacer />
          </v-card-title>
          <v-card-text>
            <div v-html="dialog.content"></div>
            <v-form ref="promptForm" v-model="isFormValid" lazy-validation>
              <v-text-field
                v-if="dialog.type === PROMPT_TYPE.TEXT"
                v-model="dialog.value"
                :label="dialog.label"
                :placeholder="dialog.placeholder"
                :rules="dialog.rules"
              >
              </v-text-field>
              <v-textarea
                v-else-if="dialog.type === PROMPT_TYPE.TEXTAREA"
                v-model="dialog.value"
                :label="dialog.label"
                :placeholder="dialog.placeholder"
                :rules="dialog.rules"
                auto-grow
                rows="1"
              >
              </v-textarea>
              <input-date-picker
                v-else-if="dialog.type === PROMPT_TYPE.DATE"
                :value.sync="dialog.value"
                :rules="dialog.rules"
                :label="dialog.label"
                :min="dialog.min"
                :max="dialog.max"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn color="accent" small elevation="0" text outlined @click="clickCancel(dialog)">{{
              $t("cancel") | capitalize
            }}</v-btn>
            <v-spacer />
            <v-btn
              :disabled="isLoading"
              small
              elevation="0"
              color="success"
              text
              outlined
              @click="clickOk(dialog, index, dialog.value)"
            >
              {{ $t("ok") | capitalize }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";
import { Resolver } from "@/models/components/popup/Resolver";
import { PROMPT_TYPE, PromptModelInterface } from "@/models/components/popup/Prompt";
import IsVisible from "@/models/components/popup/IsVisible";
import { Rejecter } from "@/models/components/popup/Rejecter";
import { VForm } from "@/models/components/inputs/vForm";
import InputDatePicker from "@/components/shared/inputs/InputDatePicker.vue";
import { ErrorHiddenFromConsole } from "@/models/ErrorHiddenFromConsole";
@Component({
  components: { InputDatePicker },
})
export default class PromptPopup extends Vue {
  PROMPT_TYPE = PROMPT_TYPE;

  get isLoading(): boolean {
    return this.$store.direct.getters.isLoading;
  }

  get popups(): Array<PromptModelInterface & Resolver & Rejecter & IsVisible> {
    return this.$store.direct.state.popup.prompts;
  }

  clickOk(item: PromptModelInterface & Resolver & IsVisible, index: number, val: string): void {
    const forms = this.$refs["promptForm"] as Array<VForm>;
    if (forms[index].validate()) {
      item.resolver(val);
      item.isVisible = false;
    }
  }
  clickCancel(item: PromptModelInterface & Rejecter & IsVisible): void {
    item.rejecter(new ErrorHiddenFromConsole("Action cancelled by user"));
    item.isVisible = false;
  }

  // popups: [];
}
</script>

<style lang="scss" scoped></style>
